import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useNavigate } from "react-router-dom";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "./../../../component/atoms/text/pretendardText";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import { errorHandler } from "../../../util/errorHandler";
import { route } from "./../../../router/route";
import ProductApi from "../../../api/product.api";
import styled from "styled-components";
import { toast } from "react-toastify";

const SecretDetail = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_membership_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getProductInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 목차/커리큘럼 설정",
    "03. 썸네일 및 배너 설정",
  ];

  // ---------- 상품 관련 ---------- //
  const [productInfo, setProductInfo] = useState({});
  const [isIntroLoading, setIsIntroLoading] = useState(false);
  const [isContentLoading, setIsContentLoading] = useState(false);

  // 상품 리스트 가져오기
  const getProductInfo = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        merchType: "SECRET",
      };

      const listResponse = (await ProductApi.getListProduct(data)).data.data
        .content[0];

      const response = (await ProductApi.getByIdProduct(listResponse?.id)).data
        .data.content;

      setProductInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 저장하기 ---------- //
  const handleUpload = async () => {
    try {
      const data = {
        intro: productInfo.intro,
        content: productInfo.content,
      };

      const response = await ProductApi.updateProduct(productInfo.id, data);
      toast("저장되었습니다.");
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  selected={item === pageTitleList[0]}
                  onClick={() => {
                    if (item === pageTitleList[0]) {
                      return;
                    } else if (item === pageTitleList[1]) {
                      navigate(route.secret_detail_curriculum);
                    } else if (item === pageTitleList[2]) {
                      navigate(route.secret_detail_image);
                    }
                  }}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>01. 기본 내용 설정</TableTitle>
          <EditorContainer>
            {/* 일급비밀 소개 */}
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              일급비밀 소개
            </PretendardText>
            <TextFormEditor
              placeholder={
                "상세 내용을 입력해주세요 (소개, 상세페이지 이미지 등)"
              }
              value={productInfo.intro}
              isLoading={isIntroLoading}
              setIsLoading={setIsIntroLoading}
              onChange={(value) => {
                setProductInfo({
                  ...productInfo,
                  intro: value,
                });
              }}
              editorHeight={600}
              style={{
                width: "100%",
              }}
            />

            {/* 일급비밀 안내 */}
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "#aaa",
              }}
            >
              일급비밀 안내
            </PretendardText>
            <TextFormEditor
              placeholder={
                "안내사항을 입력해주세요 (주의사항, 구매 방법, 인삿말, Q&A 등)"
              }
              value={productInfo.content}
              isLoading={isContentLoading}
              setIsLoading={setIsContentLoading}
              onChange={(value) => {
                setProductInfo({
                  ...productInfo,
                  content: value,
                });
              }}
              editorHeight={600}
              style={{
                width: "100%",
              }}
            />
          </EditorContainer>

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn onClick={handleUpload}>업로드하기</BasicBtn>
            <BasicBtn
              onClick={() => {
                navigate(route.secret_detail_curriculum);
              }}
            >
              다음으로
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default SecretDetail;

const EditorContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
